// Local guest cart + wishlist helpers (used before customer logs in).
const CART_KEY = "sukaanyas_guest_cart";
const WISH_KEY = "sukaanyas_guest_wishlist";

function readJSON(key, fallback) {
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
    } catch (_e) {
        return fallback;
    }
}
function writeJSON(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (_e) { /* ignore */ }
}

// ---- Guest cart ----
export function getGuestCart() {
    return readJSON(CART_KEY, []);
}
export function setGuestCart(items) {
    writeJSON(CART_KEY, items);
    window.dispatchEvent(new CustomEvent("sukaanyas:cart-changed"));
}
export function addToGuestCart(productId, size, qty = 1) {
    const items = getGuestCart();
    const match = items.find((i) => i.productId === productId && (i.size || null) === (size || null));
    if (match) {
        match.qty = Math.min(20, (match.qty || 1) + qty);
    } else {
        items.push({ id: `local-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, productId, size: size || null, qty });
    }
    setGuestCart(items);
}
export function updateGuestCartQty(itemId, qty) {
    const items = getGuestCart().map((i) => (i.id === itemId ? { ...i, qty: Math.max(1, Math.min(20, qty)) } : i));
    setGuestCart(items);
}
export function removeGuestCartItem(itemId) {
    setGuestCart(getGuestCart().filter((i) => i.id !== itemId));
}
export function clearGuestCart() {
    setGuestCart([]);
}

// ---- Guest wishlist ----
export function getGuestWishlist() {
    return readJSON(WISH_KEY, []);
}
export function setGuestWishlist(ids) {
    writeJSON(WISH_KEY, ids);
    window.dispatchEvent(new CustomEvent("sukaanyas:wishlist-changed"));
}
export function addToGuestWishlist(productId) {
    const ids = getGuestWishlist();
    if (!ids.includes(productId)) {
        ids.push(productId);
        setGuestWishlist(ids);
    }
}
export function removeFromGuestWishlist(productId) {
    setGuestWishlist(getGuestWishlist().filter((id) => id !== productId));
}
export function clearGuestWishlist() {
    setGuestWishlist([]);
}
